export default "__VITE_ASSET__c4b7066f__"